import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userInfo: [],
  userId: null,
  employeeId: null,
  firstName: null,
  surName: null,
  lastName: null,
  numberPhone: null,
  email: null,
  token: null,
  dataOfBirth: null,
  division: null,
  position: null,
  department: null,
  uniqueCodeUser: null,
  imeag: '',
  image: '',
  avatar_url: '',
  photo_url: '',
  userAvatar: null,
  employee: '',
  menu_navigate_position: null,
  erp_role: null,
  erp_access: {},
  is_superuser: false,
  has_pin: false,
  has_password: false,
  is_report_only: false,
  username: '',
  assignments: {},
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.email = action.payload.email
      state.token = action.payload.token
      state.userId = action.payload.user ?? action.payload.user_id
      state.employeeId = action.payload.id
      state.firstName = action.payload.first_name
      state.surName = action.payload.surname
      state.lastName = action.payload.last_name
      state.numberPhone = action.payload.number_phone
      state.dataOfBirth = action.payload.data_of_birth
      state.division = action.payload.division
      state.position = action.payload.position
      state.uniqueCodeUser = action.payload.unique_code_user
      const photo = action.payload.avatar_url || action.payload.photo_url || action.payload.imeag || ''
      state.image = photo
      state.imeag = photo
      state.avatar_url = photo
      state.photo_url = photo
      state.userAvatar = { ...action.payload, imeag: photo, avatar_url: photo, photo_url: photo }
      state.pin = action.payload.pin
      state.is_head_of = action.payload.is_head_of
      state.is_mol_of = action.payload.is_mol_of
      state.is_admin_of = action.payload.is_admin_of
      state.is_support_of = action.payload.is_support_of
      state.is_report_of = action.payload.is_report_of
      state.is_online = action.payload.is_online
      state.is_stud = action.payload.is_stud
      state.is_order_regist_of = action.payload.is_order_regist_of;
      state.is_admin_of_news = action.payload.is_admin_of_news;
      state.is_admin_of_accountant = action.payload.is_admin_of_accountant;
      state.is_personal_kyrgyzkomur = action.payload.is_personal_kyrgyzkomur;
      state.position = action.payload.position;
      state.department = action.payload.department_name || action.payload.department || null
      state.user_type = action.payload.user_type
      state.efficiency = action.payload.efficiency
      state.them = action.payload.them
      state.menu_navigate_position = action.payload.menu_navigate_position
      state.erp_role = action.payload.erp_role
      state.erp_access = action.payload.erp_access || {}
      state.is_superuser = !!action.payload.is_superuser
      state.has_pin = !!action.payload.has_pin
      state.has_password = !!action.payload.has_password
      state.is_report_only = !!action.payload.is_report_only
      state.username = action.payload.username || ''
      state.interface_language = action.payload.interface_language || null
      state.assignments = action.payload.erp_assignments || action.payload.assignments || {}
      
    },

    setUserInfo: (state, action) => {
      state.userInfo = action.payload.userInfo
    },
    setUserAvatar: (state, action) => {
      state.userAvatar = action.payload.userAvatar
    },
    removeUser(state) {
      return { ...initialState }
    },
    postMail(state, action) {
      state.email = action.payload.email
    },
    changeImageAvatar(state, action) {
      state.imeag = action.payload.imeag
      state.image = action.payload.imeag
      state.avatar_url = action.payload.imeag
      state.photo_url = action.payload.imeag
      state.userAvatar = { ...state.userAvatar, imeag: action.payload.imeag, avatar_url: action.payload.imeag, photo_url: action.payload.imeag }
    },
    changePassword(state, action) {
      state.new_password = action.payload.new_password
    },
    changePinCode(state, action) {
      state.pin = action.payload.pin
    },
    setEmployeeUserId(state, action) {
      state.employee = action.payload.employee
    },
    changePhoneNumber(state, action) {
      state.numberPhone = action.payload.numberPhone
    },
    changeThemeAction (state, action) {
      state.them = action.payload.them
    },
    changeNavigatePosition (state, action) {
      state.menu_navigate_position = action.payload.menu_navigate_position
    },
  },
})

export const {
  setUser,
  removeUser,
  postMail,
  changeImageAvatar,
  setUserInfo,
  setUserAvatar,
  changePassword,
  changePinCode,
  setEmployeeUserId,
  changePhoneNumber,
  changeThemeAction,
  changeNavigatePosition,
} = userSlice.actions

export default userSlice.reducer
